import { Dispatch } from "redux";
import { setWarningMessage } from "../../Redux/Slices/alert.slice";

export const validateResultData = (
  data: {
    resultLabel: string;
    resultCode: string;
    schoolBranchId: number | null;
  },
  dispatch: Dispatch
) => {
  const { resultLabel, resultCode, schoolBranchId } = data;

  if (!resultLabel) {
    dispatch(setWarningMessage("Please enter result label."));
    return false;
  }

  if (!resultCode) {
    dispatch(setWarningMessage("Please enter result code."));
    return false;
  }

  if (!schoolBranchId) {
    dispatch(setWarningMessage("Please select school branch."));
    return false;
  }

  return true;
};
